import type { FC } from "react";
import React from "react";

export const NotFoundPage: FC = () => <h1>Страница не найдена</h1>;
